import { TableColumn } from '@shared';
import type { FilterOption } from '@shared/components/filter-dropdown/filter-dropdown.component';

/**
 * Column definitions for the dealer table (flat structure).
 */
export const DEALER_COLUMNS: TableColumn[] = [
    { field: 'dealerAlias', header: 'Dealer Alias', width: '160px', hasRedirect: true },
    { field: 'businessName', header: 'Business Name', width: '180px', hasRedirect: true },
    { field: 'contactPerson', header: 'Contact Person', width: '160px' },
    { field: 'age', header: 'Age', width: '80px' },
    { field: 'total1', header: 'Total', width: '80px' },
    { field: 'unassigned', header: 'Unassigned', width: '110px' },
    { field: 'online', header: 'Online', width: '80px' },
    { field: 'offline', header: 'Offline', width: '80px' },
    { field: 'total2', header: 'Total', width: '80px' },
    { field: 'schedule', header: 'Schedule', width: '100px' },
    { field: 'active1', header: 'Active', width: '80px' },
    { field: 'total3', header: 'Total', width: '80px' },
    { field: 'active2', header: 'Active', width: '80px' },
    { field: 'status', header: 'Status', width: '100px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '100px',
        type: 'actions',
        actions: [{ icon: 'delete', name: 'delete', color: '#E73535' }],
    },
];

/**
 * Column definitions for the dealer table (grouped header structure).
 */
export const DEALER_GROUPED_COLUMNS: TableColumn[] = [
    { field: 'dealerAlias', header: 'Dealer Alias', width: '160px', hasRedirect: true },
    { field: 'businessName', header: 'Business Name', width: '180px', hasRedirect: true },
    { field: 'contactPerson', header: 'Contact Person', width: '160px' },
    { field: 'age', header: 'Age', width: '80px' },
    {
        field: 'licenses',
        header: 'Licenses',
        children: [
            { field: 'total1', header: 'Total', width: '80px' },
            { field: 'unassigned', header: 'Unassigned', width: '110px' },
            { field: 'online', header: 'Online', width: '80px' },
            { field: 'offline', header: 'Offline', width: '80px' },
        ],
    },
    {
        field: 'hosts',
        header: 'Hosts',
        children: [
            { field: 'total2', header: 'Total', width: '80px' },
            { field: 'schedule', header: 'Schedule', width: '110px' },
            { field: 'active1', header: 'Active', width: '80px' },
        ],
    },
    {
        field: 'advertisers',
        header: 'Advertisers',
        children: [
            { field: 'total3', header: 'Total', width: '80px' },
            { field: 'active2', header: 'Active', width: '110px' },
        ],
    },
    { field: 'status', header: 'Status', width: '100px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '100px',
        type: 'actions',
        actions: [{ icon: 'delete', name: 'delete', color: '#E73535' }],
    },
];

/**
 * Dropdown config for status filter.
 */
export const DEALER_STATUS_FILTER_CONFIG = {
    options: [
        { label: 'Online', value: 'online' },
        { label: 'Offline', value: 'offline' },
    ],
    placeholder: 'Status',
    fullWidth: false,
};

/**
 * Filter options shown in the "Filter by" dropdown.
 */
export const DEALER_FILTER_OPTIONS: FilterOption[] = [
    {
        label: 'Total Count',
        expanded: false,
        children: [
            {
                label: 'Licenses',
                expanded: false,
                children: [
                    { label: '0-5 licenses', checked: false },
                    { label: '6-10 licenses', checked: false },
                    { label: '11 and above licenses', checked: false },
                ],
            },
            {
                label: 'Hosts',
                expanded: false,
                children: [
                    { label: '0-5 hosts', checked: false },
                    { label: '6-10 hosts', checked: false },
                    { label: '11 and above hosts', checked: false },
                ],
            },
        ],
    },
    {
        label: 'Age',
        expanded: false,
        children: [{ label: '0-3 months' }, { label: '4-9 months' }, { label: 'Above 10 months' }],
    },
    {
        label: 'Unassigned',
        expanded: false,
        children: [
            { label: 'Less than 20%' },
            { label: 'Greater than 10%' },
            { label: 'Greater than 20%' },
        ],
    },
];

/**
 * Default page size for dealers list.
 */
export const DEALER_PAGE_SIZE = 10;
